export type AdminRouteMeta = {
  title: string;
  description?: string;
  environmentScoped?: boolean;
};

const exactRoutes: Record<string, AdminRouteMeta> = {
  "/dashboard": {
    title: "Dashboard",
    description: "Authorization activity and operational overview for the active environment.",
    environmentScoped: true
  },
  "/requests": {
    title: "Requests",
    description: "Authorization attempts, decisions, and approval state.",
    environmentScoped: true
  },
  "/approvals": {
    title: "Approver inbox",
    description: "Pending human decisions. Approving or rejecting removes the item immediately.",
    environmentScoped: true
  },
  "/policies": {
    title: "Policies",
    description: "Control how each action type is authorized. Changes apply to new requests only.",
    environmentScoped: true
  },
  "/policies/new": {
    title: "New policy",
    description: "Define authorization rules for an action type.",
    environmentScoped: true
  },
  "/audit": {
    title: "Audit log",
    description:
      "Immutable, hash-chained product audit for this workspace. IdP sign-in events are not included.",
    environmentScoped: true
  }
};

export const getAdminRouteMeta = (pathname: string): AdminRouteMeta | null => {
  if (pathname.startsWith("/settings")) {
    return null;
  }

  const exact = exactRoutes[pathname];
  if (exact !== undefined) {
    return exact;
  }

  if (/^\/requests\/[^/]+$/u.test(pathname)) {
    return null;
  }

  if (/^\/policies\/[^/]+/u.test(pathname) && pathname !== "/policies/new") {
    return null;
  }

  return null;
};

const settingsEnvironmentScopedPaths = new Set([
  "/settings/approver-groups",
  "/settings/api-keys",
  "/settings/connectors"
]);

export const isEnvironmentScopedPath = (pathname: string): boolean => {
  if (settingsEnvironmentScopedPaths.has(pathname)) {
    return true;
  }
  const meta = getAdminRouteMeta(pathname);
  if (meta?.environmentScoped === true) {
    return true;
  }
  return false;
};
